import React from 'react';
import '../css/pantalla.css';

const Pantalla = ({ input }) => {
  return <div className='input'>{input}</div>;
};

export default Pantalla;
